import { render, staticRenderFns } from "./PropertyRow.vue?vue&type=template&id=08c94cd6"
import script from "./PropertyRow.vue?vue&type=script&lang=js"
export * from "./PropertyRow.vue?vue&type=script&lang=js"
import style0 from "./PropertyRow.vue?vue&type=style&index=0&id=08c94cd6&prod&lang=postcss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports